import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Union } from "@/__main__/data-model.mjs";
import { newUserModel, userModel } from "@/feature-auth/models/user-model.mjs";

export const model = {
  me: Union([userModel, newUserModel]),
} satisfies ModelDefinition;

const GetMeResponseModel = createModel({
  data: model,
}).transform(model.me, (data) => data.data.me);

export type GetMeResponse = FromModel<typeof GetMeResponseModel>;

export default GetMeResponseModel;
